import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getFlightFaresApi } from './getFlightFares.api'
import getFlightFaresInitialState from './getFlightFares.initialState'
import { GetFlightFaresErrorResponse, GetFlightFaresRequestPayload } from './getFlightFares.types'

export const getFlightFares = createAsyncThunk(
  urls.flights.getFlightFares,
  async (payload: GetFlightFaresRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getFlightFaresApi(request)

      onSuccess && onSuccess(response.data)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getFlightFaresSlice = createSlice({
  name: urls.flights.search,
  initialState: getFlightFaresInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFlightFares.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getFlightFares.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getFlightFares.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetFlightFaresErrorResponse
        state.success = null
      })
  }
})

export const { actions: getFlightFaresActions, reducer: getFlightFaresReducer } = getFlightFaresSlice
export default getFlightFaresSlice.reducer
